import { SIGN_UP_KEY, OTHER_SKIP } from './keys'
const initialState = { signUpData: null }
export default function reducer(state = initialState, action) {
    switch (action.type) {
        case SIGN_UP_KEY: {
            return { ...state, signUpData: action.payload }
        }
        case OTHER_SKIP: {
            var { signUpData } = state
            if (signUpData && Object.keys(signUpData).length > 0) {
                signUpData["redirect"] = action.payload
            }

            return { ...state, signUpData }
        } default:
            return { ...state }
    }

}